module.exports = __webpack_public_path__ + "static/steve.58c8b6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/master_class/steve.png
// module id = 574
// module chunks = 149428911916780